import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Col, Collapse, Row } from 'antd';
import { ClassificatorField } from '../../atoms';
import { FormActions } from '../../components';
import { notificationFilterFields } from '../../constants/formNotificationsFilter';
import { notificationRelatedObjectGroup } from '../../constants/classificators';
import FormStateToRedux from '../FormStateToRedux';

const { Panel } = Collapse;

export class NotificationsFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isAuctionsEnabled: PropTypes.bool.isRequired,
  };

  onClear = (form) => {
    form.restart({});
    // Trigger search with empty filter after clear
    this.props.onSubmit({});
  };

  render() {
    const { t, form: formName, onSubmit, isAuctionsEnabled } = this.props;

    return (
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form }) => (
          <Collapse>
            <Panel key="notifications-filter" header={t('filter.panelTitle')}>
              <form onSubmit={handleSubmit}>
                <FormStateToRedux form={formName} />
                <Row gutter={24}>
                  <Col span={8}>
                    <Field
                      name={notificationFilterFields.RELATED_OBJECT_TYPE}
                      label={t('filter.objectType')}
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.notificationRelatedObjectGroup
                      }
                      hasFeedback={false}
                      allowed={
                        isAuctionsEnabled
                          ? Object.values(notificationRelatedObjectGroup)
                          : [
                              notificationRelatedObjectGroup.TS_AGREEMENT,
                              notificationRelatedObjectGroup.OTHER,
                            ]
                      }
                    />
                  </Col>
                </Row>
                <FormActions>
                  <Button onClick={() => this.onClear(form)}>
                    {t('filter.clearBtn')}
                  </Button>
                  <Button type="primary" htmlType="submit">
                    {t('filter.submitBtn')}
                  </Button>
                </FormActions>
              </form>
            </Panel>
          </Collapse>
        )}
      />
    );
  }
}

export default connect()(NotificationsFilter);
